"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCheckbox;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _form = require("@sharingapples/form");

function useCheckbox(name) {
  var _useFormInput = (0, _form.useFormInput)(name),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      selectedValues = _useFormInput2[0],
      onChange = _useFormInput2[1];

  var handleChange = _react["default"].useCallback(function (e) {
    var target = e.target;
    onChange(function () {
      if (target.checked) return [].concat((0, _toConsumableArray2["default"])(selectedValues), [target.value]);
      return selectedValues.filter(function (v) {
        return v !== target.value;
      });
    });
  }, [onChange, selectedValues]);

  return [selectedValues, handleChange];
}